import { SubscriptionPackageSetting } from "./settingComponents"

const settingsList = [
  {
    type: "subscriptionPackage",
    category: "settings",
    defaults: { enabled: false },
    component: SubscriptionPackageSetting,
  },
]

export default settingsList
